import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("columns3", component(opts));
  editor.BlockManager.add("columns3", block(opts));
};